import { detectWebView } from './jsbridge';

export function detectSys() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 检测是否为iOS设备
    if (/iPhone|iPod|iPad/i.test(userAgent)) {
        return "iOS";
    }
    // 检测是否为Android设备
    else if (/android/i.test(userAgent)) {
        return "Android";
    }
    // 如果不是iOS或Android，则返回未知
    else {
        return "unknown";
    }
}

export function detectScreen() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 判断是否为移动设备（包括手机和平板）
    var isMobile = /iPhone|iPod|iPad|Android|BlackBerry|IEMobile|Windows Phone/i.test(userAgent);

    // 更精确地判断是否为平板
    var isTablet = /iPad/i.test(userAgent) || (/(Android)/i.test(userAgent) && window.screen.width > 600);

    if (!isMobile) {
        // 非移动设备视为电脑
        return "pc";
    } else if (isTablet) {
        // 如果是移动设备且判定为平板
        return "pad";
    } else {
        // 否则视为手机
        return "phone";
    }
}

export function detectEnvironment() {
    const webViewInfo = detectWebView();
    
    if (webViewInfo.isWebView) {
        return "webview";
    }
    
    return "browser";
}